// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderBrand_root__cM5Y4","link":"HeaderBrand_link__rQB1n","logo":"HeaderBrand_logo__m34v1"};